import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const groupedFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.list.filters.grouped.yes'),
  type: 'in',
  options: {
    options: [
      { label: i18n.t('expenses_v2.list.filters.grouped.yes'), value: 'true' },
      { label: i18n.t('expenses_v2.list.filters.grouped.no'), value: 'false' },
    ],
  },
})
